(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etiquette-produits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aurora-product-badges')) {
    customElements.define(
      'aurora-product-badges',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;

          this.controller = new AbortController();
          this.badges = new Map();
          this.frame = null;

          this.schedule = () => {
            if (!this.isConnected || this.frame !== null) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.refresh();
            });
          };

          const options = {
            signal: this.controller.signal
          };

          document.addEventListener(
            'DOMContentLoaded',
            this.schedule,
            options
          );

          document.addEventListener(
            'shopify:section:load',
            this.schedule,
            options
          );

          document.addEventListener(
            'shopify:section:reorder',
            this.schedule,
            options
          );

          document.addEventListener(
            'product-info:loaded',
            this.schedule,
            options
          );

          window.addEventListener(
            'pageshow',
            this.schedule,
            options
          );

          window.addEventListener(
            'resize',
            this.schedule,
            options
          );

          document.addEventListener(
            'load',
            (event) => {
              if (event.target instanceof HTMLImageElement) {
                this.schedule();
              }
            },
            {
              capture: true,
              signal: this.controller.signal
            }
          );

          this.observedSizes = new Set();

          if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.schedule);
          }

          this.observer = new MutationObserver((records) => {
            const relevant = records.some((record) => {
              const target = record.target.nodeType === 1
                ? record.target
                : record.target.parentElement;

              if (
                target &&
                target.closest('.aurora-product-badge')
              ) {
                return false;
              }

              if (record.type !== 'childList') {
                return true;
              }

              return [
                ...record.addedNodes,
                ...record.removedNodes
              ].some((node) => {
                return (
                  node.nodeType === 1 &&
                  !node.matches('.aurora-product-badge')
                );
              });
            });

            if (relevant) {
              this.schedule();
            }
          });

          this.observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
              'href',
              'data-product-id',
              'data-url',
              'src',
              'srcset'
            ]
          });

          this.schedule();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.resizeObserver?.disconnect();
          this.observedSizes?.clear();
          this.controller?.abort();

          if (this.frame !== null) {
            cancelAnimationFrame(this.frame);
          }

          this.badges?.forEach((badge, anchor) => {
            badge.remove();

            anchor.classList.remove(
              'aurora-badge-anchor',
              'aurora-badge-relative'
            );
          });

          this.badges?.clear();
          this.controller = null;
          this.frame = null;
        }

        productHandle(url) {
          try {
            const parsed = new URL(url, location.origin);

            if (parsed.origin !== location.origin) {
              return '';
            }

            const match = parsed.pathname.match(
              /\/products\/([^/]+)/
            );

            return match
              ? decodeURIComponent(match[1])
              : '';
          } catch (_) {
            return '';
          }
        }

        customPhotoAnchor(link, photo) {
          let anchor = photo.parentElement;
          const main = link.closest('main, #MainContent');

          while (anchor && anchor !== main) {
            const display = getComputedStyle(anchor).display;

            if (display !== 'inline' && display !== 'contents') {
              break;
            }

            anchor = anchor.parentElement;
          }

          if (!anchor || anchor === main) {
            return null;
          }

          const handle = this.productHandle(link.href);

          const otherProduct = [
            ...anchor.querySelectorAll('a[href*="/products/"]')
          ].some((other) => {
            const otherHandle = this.productHandle(other.href);

            return otherHandle && otherHandle !== handle;
          });

          return otherProduct ? null : anchor;
        }

        photoOffsets(anchor, photo) {
          const box = anchor.getBoundingClientRect();
          const image = photo.getBoundingClientRect();

          if (
            !image.width ||
            !image.height ||
            !box.width ||
            !box.height
          ) {
            return null;
          }

          const scaleX = box.width / (
            anchor.offsetWidth || box.width
          );

          const scaleY = box.height / (
            anchor.offsetHeight || box.height
          );

          const left = (
            image.left - box.left
          ) / scaleX - anchor.clientLeft + anchor.scrollLeft;

          const top = (
            image.top - box.top
          ) / scaleY - anchor.clientTop + anchor.scrollTop;

          const width = image.width / scaleX;
          const height = image.height / scaleY;

          const pixels = (value) => {
            return Math.max(0, value).toFixed(2) + 'px';
          };

          return {
            '--aurora-photo-top': pixels(top),
            '--aurora-photo-left': pixels(left),
            '--aurora-photo-right': pixels(
              anchor.clientWidth - left - width
            ),
            '--aurora-photo-bottom': pixels(
              anchor.clientHeight - top - height
            ),
            '--aurora-photo-width': pixels(width)
          };
        }

        refresh() {
          if (!this.isConnected) return;

          const source = this.querySelector(
            '[data-aurora-badge-config]'
          );

          if (!source) return;

          let config;

          try {
            config = JSON.parse(source.textContent);
          } catch (_) {
            return;
          }

          const wanted = new Map();

          if (
            config.enabled &&
            config.label &&
            config.products?.length
          ) {
            const ids = new Set(
              config.products.map((product) => String(product.id))
            );

            const handles = new Set();

            config.products.forEach((product) => {
              if (product.handle) {
                handles.add(product.handle);
              }

              const localizedHandle = this.productHandle(
                product.url
              );

              if (localizedHandle) {
                handles.add(localizedHandle);
              }
            });

            if (config.cards) {
              document.querySelectorAll(
                '.product-card-wrapper'
              ).forEach((card) => {
                const link = card.querySelector(
                  'a[id^="CardLink-"], ' +
                  'a[id^="StandardCardNoMediaLink-"]'
                ) || card.querySelector(
                  'a[href*="/products/"]'
                );

                if (!link) return;

                const id = link.id.match(/-(\d+)$/)?.[1];

                const selected = id
                  ? ids.has(id)
                  : handles.has(
                      this.productHandle(link.href)
                    );

                const anchor = card.querySelector(
                  '.card__inner'
                );

                if (
                  selected &&
                  anchor?.querySelector('.card__media img')
                ) {
                  wanted.set(anchor, {
                    position: config.cardPosition,
                    gallery: false
                  });
                }
              });

              document.querySelectorAll(
                'main a[href*="/products/"], ' +
                '#MainContent a[href*="/products/"]'
              ).forEach((link) => {
                if (
                  link.closest(
                    '.product-card-wrapper, ' +
                    'product-info, ' +
                    '.product-media-modal, ' +
                    'cart-drawer, ' +
                    'cart-notification, ' +
                    '.cart-items'
                  )
                ) {
                  return;
                }

                if (
                  !handles.has(
                    this.productHandle(link.href)
                  )
                ) {
                  return;
                }

                const photo = link.querySelector('img');

                if (!photo) return;

                const anchor = this.customPhotoAnchor(
                  link,
                  photo
                );

                if (anchor && !wanted.has(anchor)) {
                  wanted.set(anchor, {
                    position: config.cardPosition,
                    gallery: false,
                    photo
                  });
                }
              });
            }

            if (config.gallery) {
              document.querySelectorAll(
                'product-info'
              ).forEach((info) => {
                const id = info.dataset.productId;

                const selected = id
                  ? ids.has(id)
                  : handles.has(
                      this.productHandle(info.dataset.url)
                    );

                if (!selected) return;

                info.querySelectorAll(
                  'media-gallery .product__modal-opener--image'
                ).forEach((anchor) => {
                  if (
                    anchor.closest('product-info') === info
                  ) {
                    wanted.set(anchor, {
                      position: config.galleryPosition,
                      gallery: true
                    });
                  }
                });
              });
            }
          }

          this.badges.forEach((badge, anchor) => {
            if (
              !anchor.isConnected ||
              !wanted.has(anchor) ||
              badge.parentElement !== anchor
            ) {
              badge.remove();

              anchor.classList.remove(
                'aurora-badge-anchor',
                'aurora-badge-relative'
              );

              this.badges.delete(anchor);
            }
          });

          document.querySelectorAll(
            '.aurora-badge-anchor > .aurora-product-badge'
          ).forEach((badge) => {
            if (!wanted.has(badge.parentElement)) {
              badge.parentElement.classList.remove(
                'aurora-badge-anchor',
                'aurora-badge-relative'
              );

              badge.remove();
            }
          });

          wanted.forEach((placement, anchor) => {
            let badge = this.badges.get(anchor);

            if (!badge) {
              badge = [...anchor.children].find((child) => {
                return child.classList.contains(
                  'aurora-product-badge'
                );
              });

              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'aurora-product-badge';
                anchor.appendChild(badge);
              }

              this.badges.set(anchor, badge);
            }

            anchor.classList.add('aurora-badge-anchor');

            if (
              getComputedStyle(anchor).position === 'static'
            ) {
              anchor.classList.add('aurora-badge-relative');
            }

            if (badge.textContent !== config.label) {
              badge.textContent = config.label;
            }

            badge.dataset.position = placement.position;

            badge.dataset.reserveZoom = String(
              placement.gallery &&
              placement.position === 'top-left' &&
              !!anchor.querySelector(
                '.product__media-icon:not(.product__media-icon--none)'
              )
            );

            const styles = {
              '--aurora-background': config.background,
              '--aurora-color': config.color,
              '--aurora-font-size': config.fontSize + 'px',
              '--aurora-mobile-font-size': config.mobileFontSize + 'px',
              '--aurora-offset': config.offset + 'px',
              '--aurora-mobile-offset': config.mobileOffset + 'px',
              '--aurora-radius': config.radius + 'px'
            };

            Object.entries(styles).forEach(
              ([property, value]) => {
                if (
                  badge.style.getPropertyValue(property) !== value
                ) {
                  badge.style.setProperty(property, value);
                }
              }
            );

            if (placement.photo) {
              const offsets = this.photoOffsets(
                anchor,
                placement.photo
              );

              badge.hidden = !offsets;
              badge.style.display = offsets ? '' : 'none';

              if (offsets) {
                Object.entries(offsets).forEach(
                  ([property, value]) => {
                    if (
                      badge.style.getPropertyValue(property) !== value
                    ) {
                      badge.style.setProperty(property, value);
                    }
                  }
                );
              }
            }
          });

          const sizes = new Set();

          wanted.forEach((placement, anchor) => {
            if (placement.photo) {
              sizes.add(anchor);
              sizes.add(placement.photo);
            }
          });

          this.observedSizes.forEach((element) => {
            if (!sizes.has(element)) {
              this.resizeObserver?.unobserve(element);
              this.observedSizes.delete(element);
            }
          });

          sizes.forEach((element) => {
            if (!this.observedSizes.has(element)) {
              this.resizeObserver?.observe(element);
              this.observedSizes.add(element);
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
